import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
const [loginMessage, setLoginMessage] = useState("");
//   const openModal = () => setIsOpen(true);
//   const closeModal = () => setIsOpen(false);

 const openModal = (msg = "") => {
  setLoginMessage(msg);
  setIsOpen(true);
};

const closeModal = () => {
  setIsOpen(false);
  setLoginMessage("");
};
  return (
    <ModalContext.Provider value={{ isOpen, openModal, closeModal ,loginMessage}}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
